import React, { useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import './Extras.css'; // Import your custom CSS file



const Extras = () => {
  const navigate = useNavigate();



  return (
    <div style={{ backgroundColor: '#45BFC8', padding: '10px' }}>
    <div className="header-account-page" style={{ backgroundColor: '#45BFC8', padding: '10px' }}> 
    <div className="column-one-account">
    <div className="profile-container">

    {/*<Icon icon="material-symbols:tv-signin-outline" color="black" width="30" height="30" style={{ marginRight: '10px' }} />*/}
   
</div>



    </div>

    <div className="column-two-account">
   
    </div>
  


    </div>
    <div className="card-container">
    
    <button onClick={() => navigate('/games')} className="card-button">
            <div className="card">
              <h3>Play Games</h3>
              <Icon icon="dashicons:games" color="#000000" width="120" height="120" />
            </div>
          </button>


     <button onClick={() => navigate('/weather')} className="card-button">
            <div className="card">
              <h3>Weather Forecast</h3>
              <Icon icon="fluent-color:weather-sunny-low-20" color="#000000" width="120" height="120" />
            </div>
          </button>     

    <button onClick={() => navigate('/donate')} className="card-button">
            <div className="card">
              <h3>Donate</h3>
              <Icon icon="flat-color-icons:donate" color="#000000" width="120" height="120" />
            </div>
          </button>      
          
  </div>

    
  </div>

  );
}

export default Extras;
